import React, { useImperativeHandle} from 'react'
import { useFormik } from 'formik'
import moment from 'moment';

// components
import InputField from '../../../components/forms/InputField/InputField.component';
import SelectField from '../../../components/forms/SelectField/SelectField.component';
import FormSectionHeader from '../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import Checkbox from '../../../components/forms/Checkbox/Checkbox.component';

const stateOptions = [
    { label: "Arizona", value: "AZ" },
    { label: "California", value: "CA" },
    { label: "Nevada", value: "NV"},
]

const wageRateOptions = [
    {value:  'PW', label: 'Prevailing Wages'},
    {value: 'RC', label: 'Regular Commercial'},
    {value: 'SD', label: 'San Diego Rate'},
    {value: 'IR', label: 'Industrial Rate'}
]

const EditJob = React.forwardRef(({ prefillData = null, errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: prefillData ? {...prefillData} : {
            name: '',
            street1: '',
            street2: '',
            city: '',
            state: 'CA',
            zipcode: '',
            customerName: '',
            customerContactName: '',
            customerPhone: '',
            customerEmail: '',
            estimatedStartDate: '',
            wageRate: '',
            isActive: true,
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>

            <FormSectionHeader text='Basic Info' />
            <InputField 
                id="name"
                placeholder="Name"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.name}
                isValid={errors['name']}
            />
            <InputField
                id="estimatedStartDate"
                placeholder="Est. Start Date"
                type="date"
                onChange={value => formik.setFieldValue('estimatedStartDate', value)}
                value={formik.values.estimatedStartDate}
                required={false}
                isValid={errors['estimatedStartDate'] ? errors['estimatedStartDate'] : true}
            />
            <SelectField
                id={'wageRate'}
                label={'Wage Rate'}
                options={wageRateOptions}
                handleChange={value => formik.setFieldValue('wageRate', value.value)}
                value={formik.values.wageRate}
                required={false}
                isValid={errors['wageRate']}
            />
            <Checkbox 
                label={'Is Active'}
                type={'text'}
                id={'isActive'}
                isChecked={formik.values.isActive}
                handleChange={formik.handleChange}
            />

            <FormSectionHeader text='Address' />
            <InputField 
                id="street1"
                placeholder="Street"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.street1}
                required={false}
                isValid={errors['street1']}
            />
            <InputField 
                id="street2"
                placeholder="Suite, Unit #"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.street2}
                required={false}
                isValid={errors['street2']}
            />
            <InputField 
                id="city"
                placeholder="City"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.city}
                required={false}
                isValid={errors['city']}
            />
            <SelectField
                id={'state'}
                label={'State'}
                options={stateOptions}
                handleChange={value => formik.setFieldValue('state', value.value)}
                value={formik.values.state}
                required={false}
                isValid={errors['state']}
            />
            <InputField 
                id="zipcode"
                placeholder="Zipcode"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.zipcode}
                required={false}
                isValid={errors['zipcode']}
            />

            <FormSectionHeader text='Customer' />
            <InputField 
                id="customerName"
                placeholder="Name"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.customerName}
                required={false}
                isValid={errors['customerName']}
            />
            <InputField 
                id="customerContactName"
                placeholder="Contact Name"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.customerContactName}
                required={false}
                isValid={errors['customerContactName']}
            />
            <InputField 
                id="customerEmail"
                placeholder="Email"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.customerEmail}
                required={false}
                isValid={errors['customerEmail']}
            />
            <InputField 
                id="customerPhone"
                placeholder="Phone"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.customerPhone}
                required={false}
                isValid={errors['customerPhone']}
            />
            
        </form>
    )
})

export default EditJob;